var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "20px",
    viewBox: "0 0 27 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "footerIcMenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(-328.000000, -21.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footerIcMenu",
    transform: "translate(328.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92857143,9 C0.864,9 0,9.448 0,10 C0,10.552 0.864,11 1.92857143,11 L25.0714286,11 C26.136,11 27,10.552 27,10 C27,9.448 26.136,9 25.0714286,9 L1.92857143,9 Z",
    id: "Page-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92857143,18 C0.864,18 0,18.448 0,19 C0,19.552 0.864,20 1.92857143,20 L25.0714286,20 C26.136,20 27,19.552 27,19 C27,18.448 26.136,18 25.0714286,18 L1.92857143,18 Z",
    id: "Page-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92857143,0 C0.864,0 0,0.448 0,1 C0,1.552 0.864,2 1.92857143,2 L25.0714286,2 C26.136,2 27,1.552 27,1 C27,0.448 26.136,0 25.0714286,0 L1.92857143,0 Z",
    id: "Page-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcMenu);
export default __webpack_public_path__ + "static/media/footerIcMenu.697e8984e797020fa9065d78db7c3bce.svg";
export { ForwardRef as ReactComponent };